module.exports = __webpack_public_path__ + "static/media/youtube-theme-icon.52160b24.svg";